export default {
    setViewportDimensions(context) {
        /*called on load and on screen resize. Only items ultimately derived from viewportHeight/Width need to be reset*/
        var newSpecs = JSON.parse(JSON.stringify(context.state.global_screen_specs))
        newSpecs.viewportHeight = document.documentElement.clientHeight;
        newSpecs.viewportWidth = document.documentElement.clientWidth;
        newSpecs.workspaceHeight = newSpecs.viewportHeight - newSpecs.headerHeight;  /*header height defined in screenDimensions initial state file*/
        newSpecs.workspaceWidth = newSpecs.viewportWidth;
        context.commit('setScreenSpecs', newSpecs);
    },
    setHelpsetLayoutWidths(context, payload){
        var newSpecs = JSON.parse(JSON.stringify(context.state.global_screen_specs))
        newSpecs.tocWidthPercent = parseInt((payload.left / newSpecs.viewportWidth) * 100);
        newSpecs.topicWidthPercent = 100-newSpecs.tocWidthPercent;
        newSpecs.hs_leftSideWidthPx = newSpecs.viewportWidth * (newSpecs.tocWidthPercent/100)
        newSpecs.hs_rightSideWidthPx = newSpecs.viewportWidth * (100-newSpecs.tocWidthPercent/100)
        context.commit('setScreenSpecs', newSpecs);
    },
   setEditLayoutWidths(context, payload){
        var newSpecs = JSON.parse(JSON.stringify(context.state.global_screen_specs))
        newSpecs.hs_leftSideWidthPx = payload.left;
        newSpecs.hs_rightSideWidthPx = payload.right;
        context.commit('setScreenSpecs', newSpecs);
    }
};


